import React, { useState, useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import { FaCheckCircle, FaRegCircle } from 'react-icons/fa';
import { useSearch } from 'rsuite/esm/Picker';


const ProgressV2 = ({ stepPage, categoryQuestions, terms }) => {
    const [steps, setSteps] = useState([
        "Your Details",
        "Entry Criteria",
        "File Upload",
        "Trophy",
        "Terms"
    ]);

    useEffect(() => {
        if (categoryQuestions) {
            // const categoryQuestionsNumberTwo = categoryQuestions.filter(item => Number(item.position) !== 1);
            // if (categoryQuestionsNumberTwo.length < 1) {
            //     setSteps([
            //         "Your Details",
            //         "File Upload",
            //         "Trophy",
            //         "Terms"
            //     ]);
            // }

            const categoryQuestionsNumberTwo = categoryQuestions.filter(
                (item) => Number(item.position) === 2
            );
    
            let updatedSteps = [
                "Your Details",
                "Entry Criteria",
                "File Upload",
                "Trophy",
                "Terms"
            ];
    
            if (categoryQuestionsNumberTwo.length < 1) {
                updatedSteps = ["Your Details", "File Upload", "Trophy", "Terms"];
            }
    
            if (terms && terms == "No") {
                updatedSteps = updatedSteps.filter((step) => step !== "Terms");
            }
    
            setSteps(updatedSteps);
        }
   
    }, [categoryQuestions, terms]) 

    return (
        <>
            {steps.map((step, index) => {
                const stepNumber = index + 1;
                const isCompleted = stepNumber < stepPage;
                const isCurrent = stepNumber === stepPage;
                return (
                    <Card key={index} className="mb-3" style={{ border: isCompleted || isCurrent ? '2px solid #1ec2fe' : '' }}>
                        <CardBody 
                            className="p-2 d-flex align-items-center"
                            style={{ backgroundColor: isCurrent ? '#1ec2f3' : 'transparent'}}
                        >
                            {isCompleted ? (
                                <FaCheckCircle className="mr-2" color="#1ec2f3" />
                            ) : isCurrent ? (
                                <FaRegCircle className="mr-2 text-white circle-icon" />
                            ) : (
                                <FaRegCircle className="mr-2" color="#00000020" />
                            )}
                            {isCompleted ? (
                                 <span>{stepNumber.toString().padStart(2, '0')}. {step}</span>
                            ) : isCurrent ? (
                                <span style={{ color: "#fff" }}>{stepNumber.toString().padStart(2, '0')}. {step}</span>
                            ) : (
                                <span style={{ color:"#00000020" }}>{stepNumber.toString().padStart(2, '0')}. {step}</span>
                            )}
                        </CardBody>
                    </Card>
                );
            })}
        </>
    );
};

export default ProgressV2;